exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".purple-background{background-color:#7814ff;color:#fff}#nav{position:relative;left:0;right:0;top:0;z-index:100;margin-bottom:75px;padding:0}.title{color:#fff;font-size:20px;font-weight:600;padding:16px;text-decoration:none!important}.production-indicator{position:absolute;right:10px;padding:5px 20px;font-weight:700;border-radius:5px}.production-indicator.production{background-color:#fff;color:red}.production-indicator.review{background-color:#fff;color:green}.production-indicator.development{background-color:#fff;color:orange}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ff8e65c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TopNav.vue
// module id = 469
// module chunks = 0